import { FeatureCode } from "@wallet-manager/node-types";
import { IlistResult, Ipage } from "../../../api/types";

const translatePrefix = "ledgerCrossMerchantTransferPath";

const Pkey = FeatureCode.FeaturesLedger.CrossMerchantTransferPath;

const translateKeyObj = {
  createRequest: "create_request",
  updateExchangeRate: "update_exchange_rate",
  merchantFrom: "merchant_from",
  merchantTo: "merchant_to",
  chainNameFrom: "chain_name_from",
  chainNameTo: "chain_name_to",
  currencyFrom: "currency_from",
  currencyTo: "currency_to",
  merchantLp: "merchant_lp",
  liquidityProvider: "liquidity_provider",
  clientIdFrom: "client_id_from",
  clientIdTo: "client_id_to",
  balanceFrom: "balance_from",
  exchangeRate: "exchange_rate",
  externalReference: "external_reference",
  transactionAmountFrom: "transaction_amount_from",
  transactionAmountTo: "transaction_amount_to",
  phClientIdFrom: "ph_client_id_from",
  phClientIdTo: "ph_client_id_to",
  phTransactionAmountFrom: "ph_transaction_amount_from",
  createWarning: "create_warning",
  enter: "enter",
  successCreate: "success_create",
  merchantTab: "merchant_tab",
  liquidityProviderTab: "liquidity_provider_tab",
  operation: "operation",
  phMerchantFrom: "ph_merchant_from",
  phMerchantTo: "ph_merchant_to",
  phMerchantLp: "ph_merchant_lp",
  phChainNameFrom: "ph_chain_name_from",
  phChainNameTo: "ph_chain_name_to",
  phCurrencyFrom: "ph_currency_from",
  phCurrencyTo: "ph_currency_to",
  phLiquidityProvider: "ph_liquidity_provider",
  phExternalReference: "ph_external_reference",
  phExchangeRate: "ph_exchange_rate",
  updateExchangeRateSuccess: "update_exchange_rate_success",
  createRequestSuccess: "create_request_success",
  noExchangeRateUpdate: "no_exchange_rate_update",
  referenceAlreadyExisted: "reference_already_existed",
  creationTime: "creation_time",
  lastModifiedTime: "last_modified_time",
  lastModifiedTimeExchangeRate: "last_modified_time_exchange_rate",
  liquidityBalance: "liquidity_balance",
} as const;

type ICrossMerchantTransferExchangeRate = {
  id: string;
  path_id: string;
  liquidity_provider_merchant_id: string;
  liquidity_provider: string;
  exchange_rate: string;
  created_by: string;
  created_date: Date;
  last_modified_by: string;
  last_modified_date: Date;
  external_ref: string;
  creator_type: number;
};

type ITableRes = {
  id: string;
  from_merchant_id: string;
  from_chain_id: string;
  to_merchant_id: string;
  to_chain_id: string;
  liquidity_provider_merchant_id: string;
  from_chain_type: string;
  from_asset_name: string;
  to_chain_type: string;
  to_asset_name: string;
  liquidity_provider: string;
  status: number;
  created_by: string;
  created_date: Date;
  last_modified_by: string;
  last_modified_date: Date;
  cross_merchant_transfer_exchange_rate: ICrossMerchantTransferExchangeRate;
};

type IFilterFields = {
  fromMerchantIds: string[];
  toMerchantIds: string[];
  fromChainName: string;
  toChainName: string;
  fromAssetNames: string[];
  toAssetNames: string[];
  liquidityProviders: string[];
  liquidityProviderMerchantId?: string;
};

const initFilterFields: IFilterFields = {
  fromMerchantIds: [],
  toMerchantIds: [],
  fromChainName: "",
  toChainName: "",
  fromAssetNames: [],
  toAssetNames: [],
  liquidityProviders: [],
  liquidityProviderMerchantId: "",
};

type LiquidityBalance = {
  id: string;
  merchant_id: string;
  client_id: string;
  chain_type: number;
  chain_id: string;
  asset_name: string;
  balance: string;
  frozen_balance: string;
  created_date: string;
  last_modified_date: string;
  credit: string;
  last_ledger_transaction_id: string;
  data_signature: string;
  data_signature_version: number;
  data_signer_server_type: number;
  data_signer_server_id: string;
};

const initParams: Ipage = {
  page: 0,
  pageSize: 20,
};

type GetTableListRes = IlistResult<ITableRes>;

export {
  Pkey,
  translatePrefix,
  translateKeyObj,
  type ITableRes,
  type GetTableListRes,
  type IFilterFields,
  type LiquidityBalance,
  initFilterFields,
  initParams,
};
